(function () {
  const sections = document.querySelectorAll("[data-fp]");
  if (!sections.length) return;

  function moneyFromCents(cents, currency) {
    // We won't guess formatting; we’ll rely on Liquid for initial and just update save badge + compare display.
    // Price text replacement uses formatted strings if provided by variant JSON? Not available.
    // We'll update numeric using dataset fallback (simple) only for "save".
    return { cents, currency };
  }

  sections.forEach((section) => {
    const form = section.querySelector("form.koffi-fp__form");
    if (!form) return;

    const variantsEl = form.querySelector("[data-fp-variants]");
    if (!variantsEl) return;

    let variants = [];
    try {
      variants = JSON.parse(variantsEl.textContent || "[]");
    } catch (e) {
      variants = [];
    }

    const hiddenId = form.querySelector("[data-fp-variant-id]");
    const select = form.querySelector("[data-fp-variant-select]");
    const pillsWrap = form.querySelector("[data-fp-variant-pills]");
    const variantTitle = section.querySelector("[data-fp-variant-title]");
    const atcBtn = section.querySelector("[data-fp-atc]");

    const priceValue = section.querySelector("[data-fp-price-value]");
    const compareEl = section.querySelector("[data-fp-compare]");
    const saveEl = section.querySelector("[data-fp-save]");

    const qtyInput = form.querySelector("[data-fp-qty-input]");
    const qtyBtns = Array.from(form.querySelectorAll("[data-fp-qty]"));

    function findVariant(id) {
      const vid = Number(id);
      return variants.find((v) => Number(v.id) === vid);
    }

    function setActivePill(id) {
      if (!pillsWrap) return;
      const btns = Array.from(pillsWrap.querySelectorAll("[data-variant-id]"));
      btns.forEach((b) => b.classList.toggle("is-on", b.dataset.variantId === String(id)));
    }

    function updateUI(variant) {
      if (!variant) return;

      if (hiddenId) hiddenId.value = variant.id;

      if (variantTitle) variantTitle.textContent = variant.public_title || variant.title || "";

      // Update button state
      if (atcBtn) {
        atcBtn.disabled = !variant.available;
      }

      // Update compare + save badge (safe and accurate)
      const price = Number(variant.price);
      const compare = Number(variant.compare_at_price || 0);

      if (compareEl) {
        if (compare > price) {
          compareEl.style.display = "";
          saveEl && (saveEl.style.display = "");
          // We cannot format money exactly without Shopify format helpers;
          // so we won't replace price strings here to avoid mismatch.
          // (If you want perfect formatting, we can use Shopify.formatMoney if theme provides it.)
        } else {
          compareEl.style.display = "none";
          saveEl && (saveEl.style.display = "none");
        }
      }

      if (saveEl && compare > price) {
        const pct = Math.round(((compare - price) / compare) * 100);
        saveEl.textContent = `Save ${pct}%`;
      }
    }

    function setVariantById(id) {
      const v = findVariant(id);
      if (!v) return;

      // keep dropdown in sync
      if (select) select.value = String(v.id);

      // keep pills in sync
      setActivePill(v.id);

      updateUI(v);
    }

    if (select) {
      select.addEventListener("change", (e) => {
        setVariantById(e.target.value);
      });
    }

    if (pillsWrap) {
      pillsWrap.addEventListener("click", (e) => {
        const btn = e.target.closest("[data-variant-id]");
        if (!btn || btn.disabled) return;
        setVariantById(btn.dataset.variantId);
      });
    }

    qtyBtns.forEach((b) => {
      b.addEventListener("click", () => {
        if (!qtyInput) return;
        const cur = Math.max(1, Number(qtyInput.value || 1));
        const next = b.dataset.fpQty === "inc" ? cur + 1 : Math.max(1, cur - 1);
        qtyInput.value = String(next);
      });
    });

    // Initialize from current hidden variant id
    if (hiddenId) setVariantById(hiddenId.value);
  });
})();
